// @flow
import React from 'react';
import { motion } from 'framer-motion';
import styles from './HeroSliderItemBackground.css';
import { IMGIX_STYLE_3, imgixImageUrl, PROFILE_IMAGE_DIMS } from '../../lib/imgix';
import { defineMessages, injectIntl } from 'react-intl';
import type { IntlShape } from 'react-intl';

const messages = defineMessages({
  ariaLabel: {
    id: 'aria-labels-hero-slider-item-background',
    defaultMessage: 'Background of {title}',
  },
});

type OwnProps = {
  item: Object,
  isActive: boolean,
  isLivestreamEventGroup: boolean,
};

type Props = OwnProps & {
  intl: IntlShape,
};

function HeroSliderItemBackground({ item, isActive, isLivestreamEventGroup, intl }: Props) {
  const fullOpacity = 0.6;
  const { imageUrl } = item;

  let backgroundImage = 'none';
  let boxShadow = 'none';
  if (isLivestreamEventGroup) {
    if (imageUrl) {
      backgroundImage = `url(${imageUrl}?w=${PROFILE_IMAGE_DIMS.w}&h=${PROFILE_IMAGE_DIMS.h})`;
      boxShadow = 'inset 0 0 0 50vw rgba(0,0,0,0.75)';
    } else {
      backgroundImage = `url(${imgixImageUrl({
        path: '/assets/web/live-fallback.jpg',
        width: PROFILE_IMAGE_DIMS.w,
        height: PROFILE_IMAGE_DIMS.h,
        style: IMGIX_STYLE_3,
      })})`;
    }
  } else {
    // Using the imgix blur param instead of a CSS filter is better for browser compatibility and performance.
    backgroundImage = `url(${imgixImageUrl({
      path: imageUrl,
      style: IMGIX_STYLE_3,
      width: PROFILE_IMAGE_DIMS.w,
      height: PROFILE_IMAGE_DIMS.h,
    })})`;
  }

  return (
    <motion.div
      className={styles.backdrop}
      role="img"
      style={{ backgroundImage, boxShadow }}
      initial={{
        opacity: isActive ? fullOpacity : 0,
      }}
      animate={{
        opacity: isActive ? fullOpacity : 0,
      }}
      transition={{
        duration: 1,
      }}
      aria-label={intl.formatMessage(messages.ariaLabel, { title: item.title })}
      aria-hidden={!isActive}
      tabIndex={isActive ? 0 : -1}
    />
  );
}

export default injectIntl(HeroSliderItemBackground);
